import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import ListComponent from "../../common/lists/ListComponent";
import InfinityGridProductsCards from "../../common/cardContainers/InfinityGridProductsCards";
import { useNavigate, useOutletContext } from "react-router";
import { useSelector } from "react-redux";
import { AppQueryClient } from "../../../api/queryClient";
import { defaultStatusColors } from "../../../utils/CardUtils";
import { DeleteAllProductsFromCompany } from "./productsUtils";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import * as Library from "../../../utils/Library";
import MainWindowHeader, {
    CustomSearch,
    OrganizeBtnMenu
} from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";
import { useQueryClient } from "react-query";
import SwitchButton from "../../common/buttons/SwitchButton";
import { formatDefaultDateTime } from "../../../utils/Formatter";
import { useSearchParams } from "react-router-dom";

// #region  SCOPED CSS
const StyledPage = styled.div`
    &.hideOverflow {
        overflow-y: hidden;
        height: 100%;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }

    &.lessMarginTop {
        margin-top: -24px;
    }

    .last-update {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: right;
        font-size: 12px;
        font-weight: 400;
        line-height: normal;
        text-transform: none;
    }

    .slider.round:before {
        top: -3px;
    }

    .slider:before {
        filter: drop-shadow(0px 0px 10px var(--backgrounds-lines-n-400)) !important;
    }

    input:checked + .slider {
        background-color: var(--backgrounds-lines-n-400) !important;
    }

    .slider {
        background-color: var(--backgrounds-lines-n-400) !important;
    }

    .slider.round {
        height: 16px !important;
    }

    .switch-button {
        justify-content: end !important;
        margin-right: 24px !important;
    }
`;
// #endregion

export default function ProductPage() {
    document.title = `${APP_TITLE} - Products`;

    // #region STATES
    const prevSelectedRows = useRef([]);
    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigations = useSelector(state => state.navigationAccesses);
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const gridRef = useRef(null);
    const [searchParams] = useSearchParams();
    const productID = searchParams.get("productID");
    const productName = searchParams.get("productName");
    const [currentProduct, setCurrentProduct] = useState(null);

    const [listNumRows, setListNumRows] = useState(50);
    const [totalItems, setTotalItems] = useState(0);
    const [viewLayoutStyle, setViewLayoutStyle] = useState("Grid");
    const [searchValue, setSearchValue] = useState("");

    const [deleteDialog, setDeleteDialog] = useState({
        show: false,
        GTINsFound: "--",
        labelBrandsFound: "--",
        productsFound: "--"
    });
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);

    const [readyToSavePopup, setReadyToSavePopup] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupDescription, setPopupDescription] = useState("");
    const [status, setStatus] = useState("");
    const [productIDs, setProductIDs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [data, setData] = useState(null);
    const [selectAll, setSelectAll] = useState(false);
    const [labelBrandsDropdownData, setLabelBrandsDropdownData] = useState([]);
    const [currentLabelBrandID, setCurrentLabelBrandID] = useState(null);

    //const { userData } = useContext(AppContext);
    //const userRole = userData?.role;
    //const editAccess = roleAccesse(userRole, "Retail Brand Account Admin");

    //---------- Header Filters
    const [allConnectedSeasons, setAllConnectedSeasons] = useState([]);
    const [allSeasonsList, setAllSeasonsList] = useState([]);
    const [filteredSeasons, setFilteredSeasons] = useState([]);
    //-----
    const [allLabelBrandsList, setAllLabelBrandsList] = useState([]);
    const [filteredLabelBrand, setFilteredLabelBrand] = useState([]);
    //-----
    const [requestEnabled, setRequestsEnabled] = useState(false);
    const [filterByStockOnly, setFilterByStockOnly] = useState(() => {
        const saved = localStorage.getItem("filterByStockOnly");
        return saved !== null ? JSON.parse(saved) : false;
    });

    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData
    };

    const [updateDates, setUpdateDates] = useState({
        show: false,
        dataAsOfDateTime: null,
        lastUpdatedDateTime: null
    });

    const filters = {
        labelBrandIDs: filteredLabelBrand?.map(item => item?.value),
        seasonNames: filteredSeasons?.map(item => item?.name),
        searchText: searchValue,
        withStockOnly: filterByStockOnly
    };

    const infiniteGridQuerykey = ["ProductsGrid", filters];
    const listQueryKey = ["ProductsList", filters];

    // #endregion

    // #region EFFECTS
    useEffect(() => {
        setViewLayoutStyle(props?.layoutType);

        setupHeaders(
            props,
            onClickRefreshAction,
            navigations,
            onSearch,
            onDeleteClick,
            handleSelectAll,
            selectedProducts,
            handleClearSelectedProducts,
            handleSuspendAll,
            handleRemoveAll,
            labelBrandsDropdownData,
            //----
            onSeasonChange,
            onLabelBrandChange,
            onFiltersLoaded,
            allLabelBrandsList,
            allSeasonsList,
            selectAll,
            filteredLabelBrand,
            //editAccess,
            //userRole,
            totalItems,
            searchValue,
            currentProduct,
            navigate
        );
        let allProductIDs = data?.pages?.flatMap(page => page?.data?.result?.map(product => product.productID)) ?? [];
        if (props?.layoutType === "List" && Array.isArray(data)) {
            allProductIDs = data?.map(product => product.productID);
        }
        if (
            typeof allProductIDs !== "undefined" &&
            typeof selectedProducts !== "undefined" &&
            allProductIDs?.length === selectedProducts?.length &&
            allProductIDs?.length > 0
        ) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [
        props?.layoutType,
        navigations,
        selectedProducts,
        data,
        selectAll,
        allLabelBrandsList,
        allSeasonsList,
        filteredLabelBrand,
        filteredSeasons,
        requestEnabled,
        //editAccess,
        //userRole,
        totalItems,
        searchValue,
        currentProduct
    ]);

    useEffect(() => {
        const labelBrands = JSON.parse(localStorage.getItem("labelBrands")) || [];
        const dropdownData = labelBrands.map((brand, index) => ({
            value: brand?._id,
            name: brand?.name,
            selected: index === 0 // Select the first brand
        }));
        setCurrentLabelBrandID(dropdownData?.[0]?.value);

        setLabelBrandsDropdownData(dropdownData);
    }, []);

    useEffect(() => {
        Library.removeQueries(queryClient, infiniteGridQuerykey);
        Library.removeQueries(queryClient, listQueryKey);
    }, []);

    useEffect(() => {
        if (!productName) return;
        setSearchValue(productName);
        setCurrentProduct({ productID, productName });
    }, [productName, props?.layoutType, requestEnabled]);
    // #endregion

    // #region METHODS
    const onLabelBrandChange = (selections = [], dropdownDataWithSelections = []) => {
        const newSelections = selections
            .map(selection => {
                return { ...selection, selected: selection.locked ? false : selection.selected };
            })
            .filter(selection => !selection.locked);

        const newDropdownDataWithSelections = dropdownDataWithSelections.map(selection => {
            return { ...selection, selected: selection.locked ? false : selection.selected };
        });

        const isSame = JSON.stringify(newSelections) === JSON.stringify(filteredLabelBrand);
        if (isSame) return;

        const selectedLabelBrandIDs = newSelections.map(selection => selection?.value);
        const currentLabelBrandID = selectedLabelBrandIDs?.[0] || "";

        setFilteredLabelBrand(newSelections);
        setAllLabelBrandsList(newDropdownDataWithSelections);
        filterConnectedSeasons(allConnectedSeasons, selectedLabelBrandIDs);
        setCurrentLabelBrandID(currentLabelBrandID);
    };

    const onSeasonChange = (selections, dropdownDataWithSelections) => {
        setFilteredSeasons(selections);
        setAllSeasonsList(dropdownDataWithSelections);
    };

    const onFiltersLoaded = data => {
        const defaultLabelBrand =
            sessionStorage.getItem("currentLabelBrand") || localStorage.getItem("defaultLabelBrand");
        let currentLabelBrandID = null;
        let selectedLabelBrandIDs = [];

        if (data?.connectedLabelBrands?.length) {
            const labelBrands = data?.connectedLabelBrands?.map((item, index) => {
                const defaultLabelBrandID = localStorage.getItem("defaultLabelBrand");
                let labelBrandName = item?.name;

                if (item?._id === defaultLabelBrandID) {
                    labelBrandName = `${item?.name} (default)`;
                }
                const restrictedLabelBrands = JSON.parse(localStorage.getItem("restrictedLabelBrandIDs") || "[]");
                //const locked = !(editAccess || restrictedLabelBrands.includes(item?._id));
                const locked = restrictedLabelBrands.includes(item?._id);

                return {
                    name: labelBrandName,
                    value: item?._id,
                    selected: !locked,
                    locked: locked
                };
            });

            const defaultLabelBrandObj =
                labelBrands?.find(item => item?.value === defaultLabelBrand && item?.selected) ||
                labelBrands?.find(item => item?.selected) ||
                labelBrands?.[0];
            const selectedLabelBrands = labelBrands?.filter(item => item?.selected);

            setAllLabelBrandsList(labelBrands);
            setFilteredLabelBrand(selectedLabelBrands);
            currentLabelBrandID = defaultLabelBrandObj?.value;
            selectedLabelBrandIDs = selectedLabelBrands.map(item => item?.value);
            setCurrentLabelBrandID(currentLabelBrandID);
        }

        if (data?.connectedSeasons?.length) {
            const seasons = data?.connectedSeasons?.map(item => {
                return {
                    name: item?.name,
                    value: item?.name,
                    selected: true,
                    labelBrandID: item?.labelBrandID,
                    retailBrandID: item?.retailBrandID
                };
            });

            setAllConnectedSeasons(seasons);
            setFilteredSeasons(seasons?.filter(item => item?.selected));
            filterConnectedSeasons(seasons, selectedLabelBrandIDs);
        }

        setRequestsEnabled(true);
    };

    const filterConnectedSeasons = async (allSeasons, selectedLabelBrandIDs) => {
        const labelBrandIDs = Array.isArray(selectedLabelBrandIDs)
            ? selectedLabelBrandIDs
            : [selectedLabelBrandIDs].filter(Boolean);

        let res = allSeasons?.filter(item => {
            return labelBrandIDs.includes(item?.labelBrandID);
        });

        // filter out any duplicated retailers
        res = res?.filter((item, index) => {
            return res?.findIndex(item2 => item2?.value === item?.value) === index;
        });

        setAllSeasonsList(res);
        setFilteredSeasons(res);
        //setFilteredSeasons([]); //TODO: TEMP fix
    };

    const onClickRefreshAction = () => {
        if (props?.layoutType === "List") AppQueryClient.invalidateQueries(listQueryKey);
        else {
            //else AppQueryClient.invalidateQueries(infiniteGridQuerykey);
            gridRef.current?.reset?.(infiniteGridQuerykey);
        }
    };

    const onSearch = searchValue => {
        setSearchValue(searchValue);
    };

    const onDeleteClick = async () => {
        setIsDeleteLoading(true);
        setDeleteDialog({ show: true, GTINsFound: "--", labelBrandsFound: "--", productsFound: "--" });

        const res = await DeleteAllProductsFromCompany({
            companyObjID: localStorage.getItem("currentCompanyID"),
            labelBrandID: currentLabelBrandID,
            debugMode: true
        }).finally(() => setIsDeleteLoading(false));

        if (res?.data?.status !== 200) return;

        const resData = res?.data?.data;
        const { GTINsFound, labelBrandsFound, productsFound } = resData;

        if (GTINsFound === 0 && productsFound === 0) {
            Library.showToastMessage({
                type: "warning",
                title: "No products found",
                message: "No products and GTINs found to delete."
            });
            setDeleteDialog({ show: false, GTINsFound: "--", labelBrandsFound: "--", productsFound: "--" });
            return;
        }

        setDeleteDialog({ show: true, GTINsFound, labelBrandsFound, productsFound });
    };

    const deleteRequest = async () => {
        setIsDeleteLoading(true);
        const res = await DeleteAllProductsFromCompany({
            companyObjID: localStorage.getItem("currentCompanyID"),
            labelBrandID: currentLabelBrandID,
            debugMode: false
        }).finally(() => {
            setIsDeleteLoading(false);
            setDeleteDialog({ show: false, GTINsFound: "--", labelBrandsFound: "--", productsFound: "--" });
        });
        if (res?.data?.status !== 200) return;

        const resData = res?.data?.data;
        const { productsDeleted, GTINsDeleted } = resData;

        Library.showToastMessage({
            type: "success",
            title: "All products deleted",
            message: `Successfully deleted ${productsDeleted?.deletedCount} products and ${GTINsDeleted?.deletedCount} GTINs.`
        });

        onClickRefreshAction();
    };

    /*
    const handleEdit = row => {
        // console.log("Edit product", row);
        // /products/edit/${item?.productID}
        navigate(`/products/edit/${row?.productID}`);
    };
    
    const handleRemove = row => {
        setStatus("Archived");
        setPopupTitle("DELETE PRODUCT?");
        setPopupDescription(
            "This products will be moved to Archive. If you want to delete this product permanetly, delete it from the archive."
        );
        setReadyToSavePopup(true);
        setProductIDs([row?.productID]);
    };

    const handleSuspend = row => {
        if (row?.status === "Active") {
            setStatus("Suspended");
            setPopupTitle("SUSPEND PRODUCT?");
            setPopupDescription(
                "You are about to suspend this product. Shoppers won't be able to buy or view this product."
            );
        } else if (row?.status === "Suspended") {
            setStatus("Active");
            setPopupTitle("REACTIVATE PRODUCT?");
            setPopupDescription(
                "You are about to reactivate this product. Shoppers will be able to buy or view this product again."
            );
        }
        setReadyToSavePopup(true);
        setProductIDs([row?.productID]);
    }; */

    const handleClearSelectedProducts = () => {
        setSelectedProducts([]);
        setSelectAll(false);
    };

    const hanldeUpdateStatus = () => {
        const jsonData = {
            productIDs: productIDs,
            statusEnum: status,
            labelBrandID: currentLabelBrandID
        };

        Library.makePostRequest("updateProductsStatus", jsonData, false, setIsLoading)
            .then(res => {
                const { /*data, message, */ status } = res?.data;
                if (status === 200) {
                    Library.showToastMessage({
                        type: "success",
                        title: jsonData?.statusEnum === "Archived" ? "Product deleted!" : "Product suspended!",
                        message: "The selected products were successfully moved to Archive"
                        /*jsonData?.status === "Archived"
                                ? "The selected products were successfully moved to Archive"
                                : message*/
                    });
                    onClickRefreshAction();
                    setSelectAll(false);
                    setSelectedProducts([]);
                    // Call the API to refresh the products
                }
                setReadyToSavePopup(false);
            })
            .catch(err => {
                console.log(err);
                setReadyToSavePopup(false);
            });
    };

    const handleSelectAll = selectAll => {
        if (selectAll) {
            let allProductIDs =
                data?.pages?.flatMap(page => page?.data?.result?.map(product => product?.productID)) ?? [];
            if (props?.layoutType === "List" && Array.isArray(data)) {
                allProductIDs = data?.map(product => product.productID);
            }
            setSelectedProducts(allProductIDs);
            setSelectAll(true);
        } else {
            setSelectedProducts([]);
            setSelectAll(false);
        }
    };

    const handleSuspendAll = () => {
        setStatus("Suspended");
        setPopupTitle("SUSPEND PRODUCT?");
        setPopupDescription(
            `You are about to suspend ${selectedProducts.length} products. Shoppers won't be able to buy or view these products`
        );
        setReadyToSavePopup(true);
        setProductIDs(selectedProducts);
    };

    const handleRemoveAll = () => {
        setStatus("Archived");
        setPopupTitle("DELETE PRODUCT?");
        setPopupDescription(
            "The selected products will be moved to Archive. If you want to delete this product permanetly, delete it from the archive."
        );
        setReadyToSavePopup(true);
        setProductIDs(selectedProducts);
    };

    const handleSelectedRowsChange = selectedRows => {
        const selectedProductIDs = selectedRows.map(row => row.productID);
        if (JSON.stringify(prevSelectedRows.current) !== JSON.stringify(selectedProductIDs)) {
            prevSelectedRows.current = selectedProductIDs;
            setSelectedProducts(selectedProductIDs);
        }
    };

    const onClickDetails = row => {
        navigate(`/products/details?productID=${row?.productID}&productName=${row?.styleName}`);
    };

    const onClickStock = item => {
        navigate(`/products/stock?productID=${item?.productID}&productName=${item?.styleName}`);
    };

    const onClickMetrics = item => {
        navigate(`/products/metrics?productID=${item?.productID}&productName=${item?.styleName}`);
    };
    // #endregion

    // #region LIST COMPONENT PROPS
    const listColumns = [
        {
            name: "BOtag ID",
            selector: row => row?.botagID ?? "--"
        },
        {
            name: "Brand",
            selector: row => row?.brand ?? "--"
        },
        {
            name: "Style name",
            selector: row => row?.styleName ?? "--"
        },
        {
            name: "Item nr.",
            selector: row => row?.reference ?? "--"
        },
        {
            name: "Colors",
            selector: row => row?.colorNames?.join(", ") ?? "--"
        },
        {
            name: "Sizes",
            selector: row => row?.sizes?.join(", ") ?? "--"
        },
        {
            name: "Category",
            selector: row => row?.category ?? "--"
        },
        {
            name: "My stock",
            selector: row =>
                `${row?.totalStockInStores || "0"} ${row?.lastStockCheck ? `( ${row?.lastStockCheck} )` : ""}`
        },
        {
            name: "Supplier stock",
            selector: row =>
                `${row?.supplierStock || "0"} ${
                    row?.lastSupplierStockCheck ? `( ${row?.lastSupplierStockCheck} )` : ""
                }`
        }
    ];
    // #endregion

    return (
        <StyledPage className={`lessMarginTop ${viewLayoutStyle === "Grid" ? "hideOverflow" : ""}`}>
            <FullScreenOverlay show={deleteDialog?.show}>
                <DialogBoxComponent
                    loading={isDeleteLoading}
                    loadingHeading="PREPARING..."
                    heading="Warning"
                    headingColor={isDeleteLoading ? "var(--text-icons-green-500)" : "var(--text-icons-orange-500)"}
                    title="Ready to delete products?"
                    onClickYes={deleteRequest}
                    onClickNo={() => setDeleteDialog({ show: false })}
                    cancelText="NO"
                    confirmText="YES"
                    message={`We found ${deleteDialog?.GTINsFound} GTINs from ${deleteDialog?.productsFound} products, belonging to
                     ${deleteDialog?.labelBrandsFound} label brands. Are you sure you want to delete all these Products and GTINs?`}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={readyToSavePopup}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-blue-500)"
                    title={popupTitle}
                    message={popupDescription}
                    onClickYes={() => {
                        hanldeUpdateStatus();
                    }}
                    loading={isLoading}
                    loadingHeading={
                        status === "Archived" ? "DELETING..." : status === "Suspended" ? "SUSPENDING..." : "LOADING..."
                    }
                    loaderBgColor="var(--text-icons-green-500)"
                    onClickNo={() => {
                        setReadyToSavePopup(false);
                    }}
                    cancelText="No"
                    confirmText="Yes"
                />
            </FullScreenOverlay>

            <div className="flex w-100 mb-16px">
                <div
                    className="flex justify-content-center align-items-center w-100"
                    style={{ visibility: updateDates?.show ? "visible" : "hidden" }}>
                    <div className="last-update mr-24px d-none">
                        Data as of: {updateDates?.dataAsOfDateTime ? `${updateDates?.dataAsOfDateTime}` : "--"}
                    </div>
                    <div className="last-update">Last update: {updateDates?.lastUpdatedDateTime ?? "--"}</div>
                </div>

                <div className="flex" style={{ minWidth: "200px", position: "absolute", right: "0px" }}>
                    <SwitchButton
                        title="Stock Only"
                        rightTitle="All"
                        onToogleChanged={value => {
                            const newValue = !value;
                            setFilterByStockOnly(newValue);
                            localStorage.setItem("filterByStockOnly", JSON.stringify(newValue));
                        }}
                        alwaysGreen={true}
                        style={{ minWidth: "200px", border: "0px" }}
                        value={!filterByStockOnly}
                    />
                </div>
            </div>

            {viewLayoutStyle === "Grid" && (
                <InfinityGridProductsCards
                    ref={gridRef}
                    className="grid"
                    minColumnWidth="294px"
                    queryKey={infiniteGridQuerykey}
                    //barcode={searchValue}
                    //searchName={searchValue}
                    setReadyToSavePopup={setReadyToSavePopup}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                    setData={setData}
                    onClickDetails={onClickDetails}
                    onClickMetrics={onClickMetrics}
                    currentLabelBrandID={currentLabelBrandID}
                    requestEnabled={requestEnabled}
                    filters={filters}
                    hideSelections={true}
                    setTotalItems={setTotalItems}
                    totalItems={totalItems}
                    onClickStock={onClickStock}
                    updateDates={updateDates}
                    setUpdateDates={setUpdateDates}
                    limit={30}
                    //onClickEdit={handleEdit}
                    //onClickSuspend={handleSuspend}
                    //onClickRemove={handleRemove}
                />
            )}

            {viewLayoutStyle === "List" && (
                <ListComponent
                    title="Products"
                    columns={listColumns}
                    api={{
                        useCommonPostRequest: true,
                        commonContext: "Products",
                        endpoint: "getProductsData",
                        formData: {
                            companyID: localStorage.getItem("currentCompanyID"),
                            //barcode: searchValue,
                            limit: listNumRows,
                            filters,
                            searchName: searchValue
                        },
                        onSuccess: data => {
                            if (!totalItems) setTotalItems(data?.totalCount || 0);

                            if (data?.lastUpdateDate)
                                setUpdateDates({
                                    show: true,
                                    lastUpdatedDateTime: formatDefaultDateTime(data?.lastUpdateDate, "--"),
                                    dataAsOfDateTime: formatDefaultDateTime(data?.dateAsOf, "")
                                });
                            else setUpdateDates({ show: false });

                            return data;
                        }
                        //onSuccess: mapListData
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={listQueryKey}
                    setData={setData}
                    selectedProducts={selectedProducts}
                    handleSelectedRowsChange={handleSelectedRowsChange}
                    actions={{
                        editIsVisible: false,
                        includeActions: true,
                        suspendIsVisible: true,
                        removeIsVisible: false,
                        //onClickEdit: handleEdit,
                        //onClickSuspend: handleSuspend,
                        //onClickRemove: handleRemove,
                        extraActions: [
                            {
                                title: "Details",
                                onClick: onClickDetails
                            },
                            {
                                title: "METRICS",
                                onClick: item => onClickMetrics(item)
                            },
                            {
                                title: "ORDER"
                                //onClick: item => onClickOrder(item)
                            }
                        ]
                    }}
                    includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }}
                    requestEnabled={requestEnabled}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            )}
        </StyledPage>
    );
}

// #region SMALL COMPONENTS
function setupHeaders(
    props,
    onRefreshAction,
    navigations,
    onSearch,
    onDeleteClick,
    handleSelectAll,
    selectedProducts,
    handleClearSelectedProducts,
    handleSuspendAll,
    handleRemoveAll,
    labelBrandsDropdownData,
    //-----
    onSeasonChange,
    onLabelBrandChange,
    onFiltersLoaded,
    allLabelBrandsList,
    allSeasonsList,
    selectAll,
    filteredLabelBrand,
    //editAccess,
    //userRole,
    totalItems,
    searchValue,
    currentProduct,
    navigate
) {
    const createMode = navigations?.navigationAccesses?.products?.createModeOnly;
    /*const isMarketingAccount = [
        "Brand Marketing Admin",
        "Brand Marketing Manager",
        "Brand Marketing Assistant"
    ].includes(userRole);*/
    //props.setControlBarLeftBtns([{ to: "#", disabled: true, title: "Products", icon: "fa-magnifying-glass" }]);

    const productIDSuffix = currentProduct
        ? `?productID=${currentProduct.productID}&productName=${currentProduct.productName}`
        : "";

    props.setControlBarLeftBtns([
        {
            customSearch: (
                <CustomSearch
                    enabled={true}
                    onTextChange={onSearch}
                    searchValue={searchValue}
                    onClearSearch={() => navigate("/products")}
                />
            )
        }
    ]);
    props.setControlBarCenterBtns([
        { to: "/products", active: true, disabled: false, title: "Live" },
        { to: "/products/my-defaults/seasons", active: false, title: "MY DEFAULTS" }
    ]);
    props.setControlBarRightBtns([
        { to: "/products", active: true, disabled: createMode, title: "View", icon: "eye" },
        {
            to: `/products/stock${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Sales",
            icon: "bar-chart-05"
        },
        /*{
            active: false,
            disabled: isMarketingAccount,
            title: "Delete All",
            icon: "garbage",
            onClick: !isMarketingAccount ? () => onDeleteClick() : undefined
        },*/
        {
            to: `/products/metrics${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Metrics",
            icon: "bar-line-chart"
        },
        {
            to: `/products/details${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Details",
            icon: "microscope"
        },
        {
            to: `/products/pos-export${productIDSuffix}`,
            active: false,
            disabled: false,
            title: "Export",
            icon: "upload-01"
        }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeader
                key={window.location.pathname}
                visible={true}
                layoutTypeOptions={{
                    gridEnabled: true,
                    listEnabled: true
                }}
                /* selections={{
                    enabled: true,
                    allSelected: selectAll,
                    selectedCount: selectedProducts?.length,
                    onClearSelection: handleClearSelectedProducts,
                    onSelectAll: handleSelectAll,
                    onDeleteClick: handleRemoveAll,
                    onSuspendClick: handleSuspendAll,
                    onUploadClick: undefined
                }} */
                search={{
                    visible: false
                    //searchPlaceholder: "Product name, ean code",
                    //onSearch: onSearch
                }}
                onRefreshClick={onRefreshAction}
                firstOrganize={{
                    visible: true,
                    dropdownData: allLabelBrandsList,
                    onDropdownChange: onLabelBrandChange,
                    disabled: allLabelBrandsList?.length === 1,
                    type: "multiSelect",
                    multidropdownOptions: {
                        selectAllText: "Select all label brands",
                        labelAllSelected: "All label brands",
                        labelNoneSelected: "--",
                        allItems: allLabelBrandsList
                    }
                }}
                secondOrganize={{
                    visible: true,
                    dropdownData: allSeasonsList,
                    onDropdownChange: onSeasonChange,
                    type: "multiSelect",
                    multidropdownOptions: {
                        selectAllText: "Select all seasons",
                        labelAllSelected: "All seasons",
                        labelNoneSelected: "--",
                        allItems: allSeasonsList
                    }
                }}
                pageFilters={{
                    useFilters: true,
                    filters: {
                        useConnectedLabelBrands: true,
                        //useProductsCollections: true
                        useConnectedProductSeasons: true
                    },
                    onFiltersLoaded: onFiltersLoaded
                }}
                settingsButton={{
                    visible: true,
                    enabled: false
                }}
            />
        )
    });
}

export const ServerSetupSettingsMenuComponent = () => {
    const navigate = useNavigate();

    return (
        <OrganizeBtnMenu
            items={[
                {
                    name: "Server Setup",
                    value: "serverSetup"
                }
            ]}
            onItemClick={() => navigate("/server")}
        />
    );
};
// #endregion
